module.exports = __webpack_public_path__ + "files/deb733e8ae657e1813261ce18d4aec46.png";